import { action, makeObservable, observable, toJS } from "mobx";
import { privatePost } from "../utils/NetworkService";
import { ChangeDecomalPoint } from "../utils/SessionService";
export class SaleStore {
  rootStore;


  user_market_product = [];
  user_market_exchange = {};

  member_coupon_list = [];

  member_coupon_data = {};


  sale_clover_count = 0;
  sale_clover_krw_count = 0;
  sale_clover_Token = 0;
  sale_clover_Token_commision = 0;
  clover_buy_count = 1;

  maxTokenExchangeClovercount = 0;



  grade_clover_count = 0;
  grade_clover_Token_count = 0;

  token_plus = 0;
  token_minus = 0;

  market_category = 0;

  market_brand_chack = 83;

  user_market_brand_item = 0;

  user_brand_chack = 0;

  user_brand_chack_length = 0;






  isUserMarketPage = true;
  isUserCouponPage = false;

  isCommissionButton = false;



  grade_error = "";
  grade_error_clover_exchange = "";
  grade_error_clover_token_tranCommisions = "";
  grade_error_clover_token_send = "";
  grade_error_clover_db_send = "";
  grade_error_clover_krw = "";


  sale_test_data = "";

  User_Brand_name = "";


  ProductList = [];
  BrandTable = [];
  CategoryTable = [];
  User_Product_item = {};







  constructor(root) {
    makeObservable(this, {
      sale_clover_count: observable,
      sale_clover_krw_count: observable,
      sale_clover_Token: observable,
      sale_clover_Token_commision: observable,
      grade_error: observable,
      grade_error_clover_exchange: observable,
      grade_error_clover_token_tranCommisions: observable,
      grade_error_clover_token_send: observable,
      grade_error_clover_db_send: observable,
      grade_error_clover_krw: observable,
      clover_buy_count: observable,
      grade_clover_count: observable,
      grade_clover_Token_count: observable,
      token_plus: observable,
      token_minus: observable,
      sale_test_data: observable,
      ProductList: observable,
      BrandTable: observable,
      CategoryTable: observable,
      market_category: observable,
      market_brand_chack: observable,
      isUserMarketPage: observable,
      isUserCouponPage: observable,
      user_market_brand_item: observable,
      user_market_product: observable,
      user_brand_chack: observable,
      User_Product_item: observable,
      user_brand_chack_length: observable,
      User_Brand_name: observable,
      isCommissionButton: observable,
      user_market_exchange: observable,
      member_coupon_list: observable,
      member_coupon_data: observable,
      maxTokenExchangeClovercount: observable,


      setCouponitemPage: action,
      setMemberCouponList: action,
      getMarketProductEpin: action,
      getMarketProductBuy: action,
      getProductitem: action,
      setProductitem: action,
      setCommisionButton: action,
      setuserbrandchack: action,
      setUserMarketProduct: action,
      setisUserCouponPage: action,
      setisUserMarketPage: action,
      setBranditemChack: action,
      setResetMarket: action,
      setMarketBrandChack: action,
      setMarketGoodsCategory: action,
      setMarketPLData: action,
      getMarketPLData: action,
      setMarketStatus: action,
      getMarketSEBT: action,
      getMarketCouponinfo: action,
      getMarketData: action,
      setCloverSaleData: action,
      setBuyCloverCount: action,
      setCloverCountKRW: action,
      getCloverCountKRW: action,
      setSaleUserCloverStand: action,
      getSaleUserCloverStand: action,
      getSaleUserCloverAdd: action,
      getCloverTokenSend: action,
      // getCloverTokenTranCommisions: action,
      setCloverTokenTranCommisions: action,
      getCloverExchange: action,
      setCloverExchange: action,
      setMaxTokenExchangeValue: action,

    });
    this.rootStore = root;

    this.user_market_product = [];
    this.user_market_exchange = {};

    this.member_coupon_list = [];

    this.member_coupon_data = {};




    this.sale_clover_count = 0;
    this.sale_clover_krw_count = 0;
    this.sale_clover_Token = 0;
    this.sale_clover_Token_commision = 0;
    this.clover_buy_count = 1;


    this.grade_clover_count = 0;
    this.grade_clover_Token_count = 0;

    this.token_plus = 0;
    this.token_minus = 0;

    this.market_category = 0;
    this.market_brand_chack = 83;

    this.user_market_brand_item = 0;

    this.user_brand_chack = 0;

    this.user_brand_chack_length = 0;
    this.maxTokenExchangeClovercount = 0;



    this.isUserMarketPage = true;
    this.isUserCouponPage = false;
    this.isCommissionButton = false;



    this.grade_error = "";
    this.grade_error_clover_exchange = "";
    this.grade_error_clover_token_tranCommisions = "";
    this.grade_error_clover_token_send = "";
    this.grade_error_clover_db_send = "";
    this.grade_error_clover_krw = "";


    this.User_Brand_name = "";


    this.sale_test_data = "";




    this.ProductList = [];
    this.BrandTable = [];
    this.CategoryTable = [];
    this.User_Product_item = {};








  }

  setCommisionButton(bool) {
    // console.log(bool);
    this.isCommissionButton = bool;
  }


  getCloverCountKRW(check) {

    const CloverCountKRWData = {
      'member_no': parseInt(this.rootStore?.loginStore?.loginState?.member_no),
      'clover_item': String("clover"),
    };

    const getCommissionEtherapi = '/getSaleCloverCount';
    privatePost({ api: getCommissionEtherapi, data: CloverCountKRWData }, (err, response) => {
      if (err) {
        // console.log(err);
        if (err.errorCode === 501) {
          this.grade_error_clover_krw = this.rootStore?.loginStore?.ErrorGuide_501; //잠시후 다시 시도해주세요.
          return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
        }
        else {
          this.grade_error_clover_exchange = this.rootStore?.loginStore?.ErrorGuide_clover_001; //새로고침을 시도해주세요.
          return alert(this.rootStore?.loginStore?.ErrorGuide_clover_001);//새로고침을 시도해주세요.
        }

      } else {
        /** 
         * @param {float} sale_clover_Token 
        */
        if (response?.data?.result) {
          this.setCloverCountKRW(response?.data?.result, check);
        }
        return
      }
    });

  }

  setCloverCountKRW(data, check) {


    this.sale_clover_krw_count = data?.sale_clover_krw_count;
    this.sale_clover_count = data?.sale_clover_count;
    this.grade_clover_count = data?.sale_clover_count;


    this.getCloverExchange(check);

  }



  /**
 * @param {number} member_no 맴버넘버
 * @param {string} address address
 * @param {number} sale_clover_krw_count 한화
 * @param {number} sale_clover_count 클로버
 */
  getCloverExchange(check) {// 클로버 가격 코인변환
    const address = "CloverAddress";

    /**LOCAL변 수*/
    const sale_clover_krw_count = this.sale_clover_krw_count;
    const sale_clover_count = this.grade_clover_count;



    /**Test변 수*/
    // const sale_clover_krw_count = 1000;
    // const sale_clover_count = 2000;



    const CommissionData = {
      'member_no': parseInt(this.rootStore?.loginStore?.loginState?.member_no),
      'address': String(address),
      'sale_clover_krw_count': parseInt(sale_clover_krw_count),
      'sale_clover_count': parseInt(sale_clover_count)
    };

    const getCommissionEtherapi = '/getSaleUserCloverTranCommisions';
    privatePost({ api: getCommissionEtherapi, data: CommissionData }, (err, response) => {
      if (err) {
        // console.log("getCloverExchange", err);
        if (err.errorCode === 501) {
          this.grade_error_clover_exchange = this.rootStore?.loginStore?.ErrorGuide_501; //잠시후 다시 시도해주세요.
          // RECOMMENDER CUT
          // return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
        }
        else {
          this.grade_error_clover_exchange = this.rootStore?.loginStore?.ErrorGuide_clover_001; //새로고침을 시도해주세요.
          // return alert(this.rootStore?.loginStore?.ErrorGuide_clover_001);//새로고침을 시도해주세요.
        }

      } else {
        /** 
         * @param {float} sale_clover_Token 
        */
        if (response?.data?.result) {
          this.setCloverExchange(response?.data?.result?.sale_clover_Token, check);
          this.setMaxTokenExchangeValue();
        }
        return
      }
    });
  }

  setMaxTokenExchangeValue() {

    // let stand = this.rootStore?.CoinStore?.StandData;
    // let minusValue = 0;

    // if (this.rootStore?.CoinStore?.UserCoinLockTokenValue > 0)
    //   minusValue += this.rootStore?.CoinStore?.UserCoinLockTokenValue;
    // let reservationList = this.rootStore?.CoinStore?.NotCompleteDBExchangeReservationList;
    // if (reservationList.length) {
    //   for (var i = 0; i < reservationList.length; i++) {
    //     minusValue += reservationList[i].real_token_count;
    //   }
    // }
    // let tokenToCloverReservationList = this.rootStore?.CoinStore?.NotCompleteTokenToCloverExchangeList;
    // if (tokenToCloverReservationList.length) {
    //   for (var i = 0; i < tokenToCloverReservationList.length; i++) {
    //     minusValue += tokenToCloverReservationList[i].real_token_count;
    //   }
    // }

    // let commission = this.sale_clover_Token_commision;

    // if (stand - (minusValue + commission) <= 0) {
    //   this.maxTokenExchangeClovercount = 0;
    // }
    // else {
    //   if (value == 'max') {
    //     this.maxTokenExchangeClovercount = stand - (minusValue + commission)
    //   } else {

    //     if (value > stand - (minusValue + commission)) {
    //       this.maxTokenExchangeClovercount = stand - (minusValue + commission);
    //     }
    //     else {
    //       this.maxTokenExchangeClovercount = value;
    //     }
    //   }
    // }
    // this.maxTokenExchangeClovercount = value;
  }

  /**
 * @param {float} ExData 한화 코인변환 Float = 부동 소수점 숫자로 변환하는 환경변수
 */
  setCloverExchange(ExData, check) {
    this.sale_clover_Token = ChangeDecomalPoint(ExData, 10000000000);//  코인으로 변환된 변수
    if (Math.round(ExData) > 0) {
      this.grade_clover_Token_count = ChangeDecomalPoint(ExData, 10000000000);//  코인으로 변환된 변수
    }
    else {
      this.grade_clover_Token_count = ChangeDecomalPoint(ExData, 10000000000);//  코인으로 변환된 변수
    }

    if (check === "CloverSaleDialog") {
      // this.getCloverTokenTranCommisions(check);
      this.setCloverTokenTranCommisions(ExData, check);
    }
  }


  // /**
  //  * @param {number} member_no 맴버넘버
  //  * @param {string} address address
  //  * @param {number} amount amount
  //  */
  // getCloverTokenTranCommisions(check) {
  //   // this.setCommisionButton(false);
  //   const address = "MissionAddress";
  //   const amount = Math.ceil(this.grade_clover_Token_count);



  //   /**Test변수 */
  //   // const sale_clover_krw_count = 1000;
  //   // const sale_clover_count = 2000;

  //   // 0x8324b8749f246812b81fa1810cb0dfaed30994d7

  //   const CommissionData = {
  //     'member_no': parseInt(this.rootStore?.loginStore?.loginState?.member_no),
  //     'address': String(address),
  //     // 'address': String("0x8324b8749f246812b81fa1810cb0dfaed30994d7"),
  //     'amount': parseInt(amount),
  //   };


  //   const getCommissionEtherapi = '/getTokenTranCommisions';
  //   console.log(-105);
  //   privatePost({ api: getCommissionEtherapi, data: CommissionData }, (err, response) => {
  //     if (err) {
  //       // console.log("getCloverTokenTranCommisions", err);
  //       // console.log("err");// 에러처리 고민좀 해봅세 밑에 있는건 나중에 가져오기 불편할까봐 예시들어둔거임
  //       // return alert(this.rootStore?.loginStore?.ErrorGuide_clover_001);//새로고침을 시도해주세요.
  //       // return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
  //       if (err.errorCode === 501) {
  //         this.grade_error_clover_token_tranCommisions = this.rootStore?.loginStore?.ErrorGuide_501; //잠시후 다시 시도해주세요.

  //         return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
  //       }
  //       else {
  //         this.grade_error_clover_token_tranCommisions = this.rootStore?.loginStore?.ErrorGuide_clover_001; //새로고침을 시도해주세요.
  //         return alert(this.rootStore?.loginStore?.ErrorGuide_clover_001);//새로고침을 시도해주세요.
  //       }

  //     }
  //     else {
  //       this.setCloverTokenTranCommisions(response?.data?.result, check);
  //     }
  //   });
  // }


  setCloverTokenTranCommisions(data, check) {
    // console.log("in", check);
    this.sale_clover_Token_commision = ChangeDecomalPoint(data.exchange_commission, 10000000000);
    // if (check === "Button") {
    //   this.setCommisionButton(true);
    // }
  }




  TokenToCloverExchange(data) {


    // const address = "MissionAddress";
    const token_count = this.grade_clover_Token_count + this.sale_clover_Token_commision;

    const StandData = this.rootStore.CoinStore.StandData;
    // const EtherCoinCommission = parseFloat(this.rootStore.CoinStore.EtherData) - this.sale_clover_Token_commision;
    // const transCommission = StandData - (this.sale_clover_Token_commision + amount);
    // const StandCoinCommission = StandData - amount;



    const requestData = {
      'member_no': parseInt(this.rootStore.loginStore.loginState.member_no),
      // 'address': String(address),
      'member_address': String(this.rootStore?.CoinStore?.WalletData?.address),
      // 'amount': Number(amount),
      'token_count': Number(token_count),
      'clover_count': parseInt(this.grade_clover_count),
      'exchange_fee': Number(this.sale_clover_Token_commision),
      'exchange_price': parseInt(this.sale_clover_krw_count),
      // 'commission': Number(this.sale_clover_Token_commision)
    };




    const tokenToCloverApi = '/tokenToCloverExchange';
    /**LOCAL sale_clover_token_send*/
    // if (this.grade_clover_Token_count !== 0 && this.sale_clover_Token_commision > 0) {
    // if (EtherCoinCommission > 0) {
    if (StandData - token_count > 0) {
      if (window.confirm(this.rootStore?.loginStore?.Guide_clover_CloverSale_01) === true) {
        privatePost({ api: tokenToCloverApi, data: requestData }, (err, response) => {
          if (err) {
            // console.log(err);
            // console.log("getCloverTokenSend", err);
            if (err.errorCode === 501) {
              // console.log("2");
              this.grade_error_clover_token_send = this.rootStore?.loginStore?.ErrorGuide_501;

              return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
            }
            else {
              this.grade_error_clover_token_send = this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_02;
              return alert(this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_02);//취소되었습니다
            }
          } else {
            this?.rootStore?.loginStore?.getCloverCount();
            this.rootStore?.CoinStore?.getDBCoin();

            // this.rootStore?.CoinStore?.getStandCoin();
            this.rootStore?.CoinStore?.getWalletData();

            return alert(this.rootStore?.loginStore?.DBTokenExchange_dialog_sucess);//환전신청 완료 메시지 .
            // this.getSaleUserCloverAdd();
            // console.log(response?.data?.result);
            // window.location.href = 'https://www.earn-clover.com/';//전송 완료 후 창 이동
            // return
          }
        });
      }
      else {//취소
        return alert(this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_02);//취소되었습니다
      }
    }
    else {
      return alert(this.rootStore?.loginStore?.ErrorGuide_clover_005);//코인이 부족합니다
    }
  }



  getCloverTokenSend(data) {


    const address = "MissionAddress";
    const amount = this.grade_clover_Token_count;

    const StandData = this.rootStore.CoinStore.StandData;
    // const EtherCoinCommission = parseFloat(this.rootStore.CoinStore.EtherData) - this.sale_clover_Token_commision;
    const transCommission = StandData - (this.sale_clover_Token_commision + amount);
    const StandCoinCommission = StandData - amount;



    const saleCloverTrnasferData = {
      'member_no': parseInt(this.rootStore.loginStore.loginState.member_no),
      'address': String(address),
      'amount': Number(amount),
      'commission': Number(transCommission)
    };

    // console.log("스텐드 = ", StandData);
    // console.log("이더필요 = ", this.sale_clover_Token_commision);
    // console.log("보유이더 = ", this.rootStore.CoinStore.EtherData);
    // console.log("이더합산 = ", EtherCoinCommission);
    // console.log("수수료 =", StandCoinCommission);
    // console.log("amount = ", saleCloverTrnasferData);
    // console.log(this.grade_clover_Token_count);
    // console.log("sale_clover_Token_commision = ",this.sale_clover_Token_commision);
    // console.log("amount = ",typeof amount);
    // console.log("sale_clover_Token_commision TEST = ", this.sale_clover_Token_commision > 0);


    // console.log(StandCoinCommission);



    // console.log("saleCloverTrnasferData = ", saleCloverTrnasferData ); // TEST
    // this.getSaleUserCloverAdd();// TEST





    const getsendTokenUserapi = '/sendTokenUser';
    /**LOCAL sale_clover_token_send*/
    // if (this.grade_clover_Token_count !== 0 && this.sale_clover_Token_commision > 0) {
    // if (EtherCoinCommission > 0) {
    if (transCommission > 0) {
      if (window.confirm(this.rootStore?.loginStore?.Guide_clover_CloverSale_01) === true) {
        privatePost({ api: getsendTokenUserapi, data: saleCloverTrnasferData }, (err, response) => {
          if (err) {
            // console.log(err);
            // console.log("getCloverTokenSend", err);
            if (err.errorCode === 501) {
              // console.log("2");
              this.grade_error_clover_token_send = this.rootStore?.loginStore?.ErrorGuide_501;

              return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
            }
            else {
              this.grade_error_clover_token_send = this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_02;
              return alert(this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_02);//취소되었습니다
            }
          } else {
            this.getSaleUserCloverAdd();
            // console.log(response?.data?.result);
            // window.location.href = 'https://www.earn-clover.com/';//전송 완료 후 창 이동
            // return
          }
        });
      }
      else {//취소
        return alert(this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_02);//취소되었습니다
      }
    }
    else {
      return alert(this.rootStore?.loginStore?.ErrorGuide_clover_005);//코인이 부족합니다
    }
    // }
    // else {
    //   return alert(this.rootStore?.loginStore?.ErrorGuide_clover_010);//이더리움이 부족합니다
    // }
    // }
    // else {
    //   // console.log("1");
    //   return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
    // }

    /**Test sale_clover_token_send */
    // if (window.confirm(this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_06) === true) {
    //   privatePost({ api: getsendTokenUserapi, data: saleCloverTrnasferData }, (err, response) => {
    //     if (err) {
    //       // console.log(err);
    //       if (err.errorCode === 501) {
    //         // console.log("2");
    //         this.grade_error_clover_token_send = this.rootStore?.loginStore?.ErrorGuide_501;

    //         return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
    //       }
    //       else {
    //         this.grade_error_clover_token_send = this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_02;

    //         return alert(this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_02);//취소되었습니다
    //       }
    //     } else {
    //       // this.getSaleUserCloverAdd();
    //       // console.log(response?.data?.result);
    //       // window.location.href = 'https://www.earn-clover.com/';//전송 완료 후 창 이동
    //       // return
    //     }
    //   });
    // }
    // else {//취소
    //   return alert(this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_02);//취소되었습니다
    // }



  }


  /**
   * @param {number} member_no 맴버넘버
   * @param {number} sale_clover_count 클로버
   */
  getSaleUserCloverAdd(Check) {


    const api = '/getSaleUserCloverAdd';

    /**LOCAL data*/
    const data = {
      "member_no": parseInt(this.rootStore.loginStore.loginState.member_no),
      "reward_count": parseInt(this.grade_clover_count),
    };

    /**TEST data*/
    // const data = {
    //   "member_no": parseInt(this.rootStore.loginStore.loginState.member_no),
    //   "reward_count": parseInt(1000),
    // };


    // console.log("testStandCount = ",  this.rootStore?.CoinStore?.StandData); //TEST



    privatePost({ api: api, data: data }, (err, response) => {
      if (err) {
        // console.log("getSaleUserCloverAdd",err);
        if (err.errorCode === 501) {
          // console.log("2");
          return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
        }
        else {
          return alert(this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_02);//취소되었습니다
        }
      } else {
        this?.rootStore?.loginStore?.getCloverCount();
        this.rootStore?.CoinStore?.getDBCoin();

        // this.rootStore?.CoinStore?.getStandCoin();
        this.rootStore?.CoinStore?.getWalletData();
      }
    });



  }



  getSaleUserCloverStand(Check) {

    const api = '/getSaleUserCloverSand';

    /**LOCAL data*/
    const data = {
      "member_no": parseInt(this.rootStore.loginStore.loginState.member_no),
      "reward_count": parseInt(this.grade_clover_count),
    };

    /**TEST data*/
    // const data = {
    //   "member_no": parseInt(this.rootStore.loginStore.loginState.member_no),
    //   "change_stand": this.grade_clover_count,
    // };



    if (window.confirm("구입 하시겠습니까 ?") === true) {
      privatePost({ api: api, data: data }, (err, response) => {
        if (err) {
          // console.log(err);
          if (err.errorCode === 3804) {
            // this.grade_error_clover_db_send = this.rootStore?.loginStore?.ErrorGuide_clover_005;
            return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
          }
          else {
            // return alert(this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_02);//취소되었습니다
          }
        } else {
          this.setSaleUserCloverStand(response?.data?.result);
        }
      });
    }
    else {
      return alert(this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_02);//취소되었습니다
    }


  }

  setSaleUserCloverStand() {
    this.getSaleUserCloverAdd();
    // this.rootStore?.CoinStore?.getDBCoin();
  }


  setBuyCloverCount(value) {

    if (value === "+") {
      this.clover_buy_count = this.clover_buy_count + 1;
    }
    else if (value === '-') {
      if (this.clover_buy_count > 0) {
        this.clover_buy_count = this.clover_buy_count - 1;
      }
      // if(this.clover_buy_count === 0 ) {
      //   console.log(this.clover_buy_count);
      //   this.clover_buy_count = 1;
      // }
    }
    this.setCloverSaleData(value);
    this.setCommisionButton(false);
  }

  setCloverSaleData(value) {

    let Clover_Count = this.sale_clover_count;

    let Clover_Token_Count = this.sale_clover_Token;



    // this.token_plus = 0;
    // this.token_minus = 0;




    if (value === "+") {


      this.grade_clover_count = this.grade_clover_count + Clover_Count;
      this.grade_clover_Token_count = ChangeDecomalPoint(this.grade_clover_Token_count + Clover_Token_Count, 10000000000);
    }
    else if (value === "-") {


      if (parseInt(this.grade_clover_count - Clover_Count) !== 0) {
        this.grade_clover_count = this.grade_clover_count - Clover_Count;
      }
      else {

      }
      if (this.grade_clover_Token_count > 0) {

        if (this.grade_clover_Token_count - Clover_Token_Count > 0) {
          if (this.clover_buy_count !== 0) {
            if (this.grade_clover_Token_count - Clover_Token_Count <= 0) {
              this.grade_clover_Token_count = Clover_Token_Count;
            }
            else {
              this.grade_clover_Token_count = ChangeDecomalPoint(this.grade_clover_Token_count - Clover_Token_Count, 10000000000);
            }
          }
          else {
            this.grade_clover_Token_count = this.grade_clover_Token_count;
          }
        }
        else {
          this.grade_clover_Token_count = this.grade_clover_Token_count;
        }
      }
      else {
        this.grade_clover_Token_count = this.grade_clover_Token_count;
      }

    }

    // this.getCloverTokenTranCommisions();


  }


  // 쿠폰 데이터 
  getMarketData(Data, check) {


    const api = '/getMemberCoupon';

    /**LOCAL data*/
    const data = {
      "member_no": parseInt(this.rootStore.loginStore.loginState.member_no),
    };
    // console.log("In");

    privatePost({ api: api, data: data }, (err, response) => {
      if (err) {
        // console.log("GMD",err);
        return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
        if (err.errorCode === 3804) {
          // this.grade_error_clover_db_send = this.rootStore?.loginStore?.ErrorGuide_clover_005;
        }
        else {
          // return alert(this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_02);//취소되었습니다
        }
      } else {
        // console.log(response?.data?.result);
        this.getMarketCouponinfo(response?.data?.result, check);
        // this.setMemberCouponList(response?.data?.result, check);
      }
    });

  }


  // 모바일 쿠폰 핀 상태 조회
  getMarketCouponinfo(resdata, check) {

    const api = '/getMarketCouponinfo';
    // console.log(resdata, check);

    /**LOCAL data*/
    const data = {
      "member_no": parseInt(this.rootStore.loginStore.loginState.member_no),
    };

    /** TEST data */
    // const data = {
    //   member_no: 1111 
    // };
    // console.log("In");
    if (resdata === true) {
      privatePost({ api: api, data: data }, (err, response) => {
        if (err) {
          console.log(err);
          return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
          if (err.errorCode === 3804) {
            // this.grade_error_clover_db_send = this.rootStore?.loginStore?.ErrorGuide_clover_005;
          }
          else {
            // return alert(this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_02);//취소되었습니다
          }
        } else {
          // console.log(response?.data?.result);
          this.setMemberCouponList(response?.data?.result, check);
        }
      });
    }
  }


  setMarketStatus(data) {
    this.sale_test_data = data?.member_epin;

  }

  //모바일 쿠폰 거래번호 조회
  getMarketSEBT() {

    const api = '/getMarketStatusEpinByTid';

    // let User_Product_item = toJS(this.User_Product_item);

    /**LOCAL data*/
    const data = {
      "member_no": parseInt(this.rootStore.loginStore.loginState.member_no),
      // "brandcode": parseInt(User_Product_item?.brandcode),
      // "epin": String(resdata?.epin),
    };

    // console.log("getMarketTestS", data);

    privatePost({ api: api, data: data }, (err, response) => {
      if (err) {
        // console.log(err);
        return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
        if (err.errorCode === 3804) {
          // this.grade_error_clover_db_send = this.rootStore?.loginStore?.ErrorGuide_clover_005;
        }
        else {
          // return alert(this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_02);//취소되었습니다
        }
      } else {
        // console.log(response?.data?.result);
        // this.setSaleUserCloverStand(response?.data?.result);
      }
    });


  }


  getMarketPLData(value) {

    const api = '/getMarketProductList';

    /**LOCAL data*/
    const data = {
      "member_no": parseInt(this.rootStore.loginStore.loginState.member_no),
    };



    privatePost({ api: api, data: data }, (err, response) => {
      if (err) {
        // console.log(err);
        return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
        // if (err.errorCode === 3804) {
        //   // this.grade_error_clover_db_send = this.rootStore?.loginStore?.ErrorGuide_clover_005;
        // }
        // else {
        //   // return alert(this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_02);//취소되었습니다
        // }
      } else {
        // console.log(response?.data?.result);
        this.setMarketPLData(response?.data?.result, value);
        // this.setSaleUserCloverStand(response?.data?.result);
      }
    });


  }

  setMarketPLData(data, value) {
    // console.log(data);
    this.ProductList = data?.ProductListTable;
    this.BrandTable = data?.BrandTable;
    this.CategoryTable = data?.CategoryTable;
    if (value === "CloverMarketDialog") {
      this.setMarketGoodsCategory(data?.CategoryTable[0].Index, value);
    }
  }


  setMarketGoodsCategory(value, Check) {
    // console.log(value);
    this.market_category = value;
    this.setResetMarket("Category");
    let Brand = this.BrandTable;
    let user_brand = [];
    for (let i = 0; i < Brand.length; i++) {
      if (Brand[i].Category === value) {
        // this.setuserbrandchack(Brand[i]);
        user_brand.push(Brand[i]);
      }
    }
    if (user_brand.length !== 0) {
      this.setuserbrandchack(user_brand.length);
      // console.log("user_brand",user_brand[0].Brand);
      if (Check === "CloverMarketDialog") {
        this.setMarketBrandChack(user_brand[0].Index, user_brand[0].Brand);
      }
    }

  }


  setMarketBrandChack(value, userBrand) {
    // console.log("set",value ,userBrand );
    this.market_brand_chack = value;
    this.User_Brand_name = userBrand;
  }

  setuserbrandchack(value) {
    // console.log("setuserbrandchack",value);
    if (value >= 5) {
      this.user_brand_chack_length = 5;
    }
    else {
      this.user_brand_chack_length = value;
    }
  }

  setResetMarket(value) {
    // console.log("IN", value);
    // this.setMarketGoodsCategory(1);
    if (value === "Category") {
      this.market_brand_chack = 0;
    }
    else if (value === "CouponPage") {
      this.market_category = 0;
      this.market_brand_chack = 0;
      this.isUserMarketPage = false;
    }
    else if (value === "MarketPage") {
      this.market_category = 0;
      this.market_brand_chack = 0;
      this.isUserCouponPage = false;
    }
    else {
      this.market_category = 0;
      this.market_brand_chack = 0;
      this.isUserMarketPage = true;
      this.isUserCouponPage = false;
    }


  }

  /** setBranditemChack 마켓아이템 페이지 오픈
//  * @param {number} user_market_brand_item user_market_brand_item
//  * @param {number} User_Product_item User_Product_item
 */
  setBranditemChack(value) {
    this.user_market_brand_item = value.goods_id;
    this.User_Product_item = value;
    this.rootStore.loginStore.setDialogOpen("CloverMarketProduct");
    this.getProductitem(value);
  }


  /** getProductitem 마켓아이템 페이지 오픈(item_price_exchange)
//  * @param {number} user_market_brand_item user_market_brand_item
//  * @param {number} User_Product_item User_Product_item
*/
  getProductitem(productData) {

    // console.log(productData);
    // console.log(Branddata);


    const api = '/getMarketProductPriceExchange';

    /**LOCAL data*/
    const data = {
      "member_no": parseInt(this.rootStore.loginStore.loginState.member_no),
      "price": parseInt(productData?.price),
    };



    privatePost({ api: api, data: data }, (err, response) => {
      if (err) {
        // console.log(err);
        return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
      } else {
        // console.log(response?.data?.result);
        this.setProductitem(response?.data?.result);
      }
    });
  };

  /** 마켓 가격 환전(item_price_exchange_set) */
  setProductitem(data) {
    // console.log("d", data);

    let ChangeData = {
      // commision: ChangeDecomalPoint(data?.commision, 10000000000),
      MarketPriceExchange: ChangeDecomalPoint(data?.MarketPriceExchange, 10000000000)
    };

    this.user_market_exchange = ChangeData;
  }

  getMarketProductBuy(BuyData, ExchangeCount) {

    // console.log("B",BuyData);
    // User_Product_item
    let BrandData = toJS(this.User_Product_item);
    // console.log("p",BrandData);

    const api = "/setMarketProdeuctBuy";

    // this.getMarketProductEpin(BrandData); // TEST

    // const address = "MissionAddress";
    // const EtherCoinCommission = parseFloat(this.rootStore.CoinStore.EtherData) - BuyData?.commision;
    // const StandCoinCommission = StandData - amount;

    let DBcoin = this.rootStore.CoinStore.DBData;

    // console.log("D", DBcoin);
    // console.log("B", BrandData);

    let DBCheck = parseFloat(this.rootStore.CoinStore.DBData) - parseFloat(ExchangeCount);
    // let DBCheck = parseFloat(115.8135483815) - parseFloat(ExchangeCount);


    // console.log(StandCoinCommission);
    // console.log(EtherCoinCommission);

    const amount = parseFloat(BuyData?.MarketPriceExchange);


    let data = {
      "member_no": parseInt(this.rootStore.loginStore.loginState.member_no),
      amount: amount,
      co_tid: BrandData?.co_tid,
      goods_id: BrandData?.goods_id
    };


    if (DBCheck > 0) {
      privatePost({ api: api, data: data }, (err, res) => {
        if (err) {
          // console.log(err);
          if (err.errorCode === 3804) {
            return alert(this.rootStore?.loginStore?.ErrorGuide_clover_005);//코인이 부족합니다.
          }
          else {
            return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
          }
        }
        else {
          // this.rootStore?.CoinStore?.getDBCoin();
          this.getMarketProductEpin(BrandData); // 확인 후 주석 풀어서 빌드
        }
      });
    }
    else {
      return alert(this.rootStore?.loginStore?.ErrorGuide_clover_005);//코인이 부족합니다.
    }

  }


  getMarketProductEpin(BuyData) {
    const api = "/getMarketProductStatusEpin";

    let BrandData = toJS(this.User_Product_item);


    let data = {
      member_no: this.rootStore.loginStore.loginState.member_no,
      goods_id: String(BrandData?.goods_id),
      co_tid: String(BrandData?.co_tid),
      goods_name: String(BrandData?.goods_name),
      image: String(BrandData?.image),
      price: String(BrandData?.price),
      Brand: String(BrandData?.Brand),
    };

    // console.log("IN", data);
    // this.getMarketProductBuy(BuyData); //TEST

    privatePost({ api: api, data: data }, (err, response) => {
      if (err) {
        // console.log(err);
        if (err.errorCode) {
          return alert(err.errorMessage);
        }
        else {
          return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
        }
      } else {
        // console.log(response?.data?.result);
        // this.getMarketProductBuy(BuyData);
        this.rootStore?.CoinStore?.getDBCoin();
        //페이지 이동
        this.rootStore?.loginStore?.setDialogClose('CloverMarketProductFalse');
        this.setisUserCouponPage(true, "ALL");
      }
    });

  }





  setUserMarketProduct(ProductArray) {
    this.user_market_product = ProductArray;
  }


  setisUserMarketPage(bool) {
    this.isUserMarketPage = bool;
    this.setResetMarket("MarketPage");
  }


  setisUserCouponPage(bool, check) {
    this.isUserCouponPage = bool;
    this.setResetMarket("CouponPage");
    this.getMarketData(null, check);
  }


  setMemberCouponList(MemberCouponArray, check) {
    // console.log("array", MemberCouponArray);
    let CheckData = [];
    if (check === 'ALL') {
      // this.member_coupon_list = MemberCouponArray;
      for (let i = 0; i < MemberCouponArray.length; i++) {
        CheckData.push(MemberCouponArray[i])

      }
    }
    else if (check === 'N') {

      for (let i = 0; i < MemberCouponArray.length; i++) {
        if (MemberCouponArray[i]?.member_use === "N") {
          CheckData.push(MemberCouponArray[i])
        }
      }
    }
    else if (check === 'Y') {
      for (let i = 0; i < MemberCouponArray.length; i++) {
        if (MemberCouponArray[i]?.member_use === "Y") {
          CheckData.push(MemberCouponArray[i])
        }
      }
    }
    else if (check === 'C') {
      for (let i = 0; i < MemberCouponArray.length; i++) {
        if (MemberCouponArray[i]?.member_use === "C") {
          CheckData.push(MemberCouponArray[i])
        }
      }
    }
    this.member_coupon_list = CheckData;
  }

  /**
   * 쿠폰 아이템 페이지 
   */
  setCouponitemPage(data, check) {
    // console.log("Couponitem",data);
    this.member_coupon_data = data;
    this.rootStore.loginStore.setDialogOpen("CloverMarketCouponitem");
  }

}